<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_or2"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="order_hall_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="getLimit('order_hall_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      height="80%"
      :filter-config="{ remote: true }"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <!-- <vxe-table-column>
        <vxe-table-column field="branchCode" title="机构" :formatter="formatterBranch" min-width="150" sortable />
        <template v-slot:header>
          <el-select v-model="listQuery.branchCode" placeholder="请选择" clearable>
            <el-option v-for="item in branchList" :key="item.code" :label="item.groupName" :value="item.code" />
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="dfName"
          title="经办人"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.dfName"
            placeholder="请输入经办人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createdByName"
          title="托运人名称"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.createdByName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentStaffTypeStr"
          title="托运人类型"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.shipmentStaffType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in shipmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createdByPhone"
          title="托运人电话"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.createdByPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="收货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="订单状态"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ statusMap[row.status] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="(v, k) in statusMap"
              :key="k"
              :label="v"
              :value="k"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isQuote"
          title="订单类型"
          :formatter="formatterQuote"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.supplyType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(v, k) in isQuoteMap"
              :key="k"
              :label="v"
              :value="k"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalBigTypeName"
          title="货物类型"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalBigTypeName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalName"
          title="运输要求"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalPrice"
          title="货物单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="realPrice" title="承运单价" min-width="200" />
        <template v-slot:header>
          <el-row>
            <el-col>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.realPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.realPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="distance"
          title="运输距离（公里）"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.distanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.distanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="weight"
          title="货物数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.weightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.weightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastWeight"
          title="剩余数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.lastWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.lastWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pushVehicleUse"
          title="用车类型"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.pushVehicleUse"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalNumber"
          title="需求车数(车)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalNumberStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalNumberEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="notReceivedCount"
          title="未接车数(车)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.notReceivedCountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.notReceivedCountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="receivedCount"
          title="已接车数(车)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.receivedCountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.receivedCountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="transferCount"
          title="已调单量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.transferCountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.transferCountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastLoadingTime"
          title="装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastLoadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastLoadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastUnloadingTime"
          title="卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastUnloadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastUnloadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="60">
        <template v-slot="{ row }">
          <el-tooltip
            v-if="
              order_hall_accept_button && (driverType == 0 || driverType == 1)
            "
            class="item"
            effect="dark"
            :content="
              (driverType == 0 ? '实际承运人' : '批量') +
                (row.isQuote == '0' ? '承运' : '报价')
            "
            placement="top"
          >
            <vxe-button type="text" @click="funcTake(row)">
              <i class="el-icon-s-order" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelTakeFlag"
      title="确定承运此订单?"
      width="400"
      height="auto"
      resize
    >
      <compTake
        ref="takeRef"
        @fatherTakeMethod="fatherTake"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compTake from "./components/orderTake.vue";
import request from "@/utils/request";
import { orderHallList } from "@/api/orderform";
import { getLimit } from "@/utils/getLimit.js";
export default {
  name: "OrderList",
  components: {
    compTake
  },
  data() {
    return {
      // 0:实际承运人，1:车队，2:车队实际承运人（不能接单）默认-1不是实际承运人
      driverType: -1,
      isQuoteMap: { 0: "普通单", 1: "报价单", 2: "指派单" },
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      statusMap: {
        0: "未接单",
        1: "已接单",
        2: "已装货",
        3: "已卸货",
        4: "已结算"
      },
      loading: false,
      tableData: [],
      shipmodal: false,
      jinzhis: false,
      ShipmentQuery: {
        perWeight: "",
        mainOrderCode: ""
      },
      modelTakeFlag: false,
      order_hall_search_button: false, //查询
      order_hall_accept_button: false, //承运
      listQuery: {
        lastLoadingTimeRange: "",
        lastUnloadingTimeRange: "",
        gmtCreatedRange: "",
        gmtModifiedRange: "",
        placeOfShipment: "",
        placeOfReceipt: "",
        mainOrderNumber: "",
        shipperAddress: "",
        consigneeAddress: "",
        weight: "",
        coalPrice: "",
        coalName: "",
        coalBigTypeName: "",
        coalTypeName: "",
        coalNumber: "",
        isQuote: "",
        notReceivedCount: "",
        receivedCount: "",
        transferCount: "",
        status: "",
        distance: "",
        pushVehicleUse: "",
        lastWeight: "",
        createdByName: "",
        modifiedByName: "",
        gmtLastLoadingStart: "",
        gmtLastLoadingEnd: "",
        gmtLastUnloadingStart: "",
        gmtLastUnloadingEnd: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        gmtModifiedStart: "",
        gmtModifiedEnd: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 机构列表
      branchList: this.$store.state.components.branchList,
      exportObj: {
        exportUrl: "/ntocc-tms-api/order/exportOrderHall", //导出接口
        name: "货源大厅"
      },
      sumObject: {}
    };
  },
  created() {
    const driver = this.$store.getters.driver;
    if (driver) {
      this.driverType = driver.driverType;
    }
    this.findList();
    this.order_hall_search_button = getLimit("order_hall_search_button"); //查询
    this.order_hall_accept_button = getLimit("order_hall_accept_button"); //承运
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        orderHallList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.tableData.forEach(item => {
            item.coalPrice = item.coalPrice + "元/" + item.coalUnitName;
            item.weight = item.weight + item.coalUnitName;
            item.lastWeight = item.lastWeight + item.coalUnitName;
            if (item.isQuote === "0") {
              item.realPrice = item.realPrice + item.isTrunkName;
            } else {
              item.realPrice = "***" + item.isTrunkName;
            }
          });
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    funcTake(row) {
      const dataAttrArr = [];
      let funcSubmit = "";
      // 货运单类型isQuote，{0: '普通单', 1: '报价单'},
      // 实际承运人类型driverType，{0:'实际承运人',1:'车队',2:'车队实际承运人'}（默认车队实际承运人不会看见此页面，不能接单）
      // 需求车数coalNumber，0：不限制车数，大于零时取lastCoalNumber
      if (row.isQuote === "0") {
        // 普通单
        if (this.driverType === 0) {
          // 实际承运人
          if (row.coalNumber === 0) {
            // 不限制车数
            dataAttrArr.push("perWeight");
          } else {
            // 限制车数
            // 无输入要求
          }
          funcSubmit = "TO";
        } else {
          // 队长
          if (row.coalNumber === 0) {
            // 不限制车数
            dataAttrArr.push("perWeight");
            dataAttrArr.push("coalNumber");
          } else {
            // 限制车数
            dataAttrArr.push("coalNumber");
          }
          funcSubmit = "TOB";
        }
      } else {
        // 报价单
        if (this.driverType === 0) {
          // 实际承运人
          if (row.coalNumber === 0) {
            dataAttrArr.push("bidWeight");
          }
          dataAttrArr.push("bidPrice");
          dataAttrArr.push("arrivalTime");
          funcSubmit = "BO";
        } else {
          // 队长
          if (row.coalNumber === 0) {
            dataAttrArr.push("bidWeight");
          }
          dataAttrArr.push("bidCount");
          dataAttrArr.push("bidPrice");
          dataAttrArr.push("arrivalTime");
          funcSubmit = "BOB";
        }
      }
      this.$refs.takeRef.init(row, dataAttrArr, funcSubmit);
      this.modelTakeFlag = true;
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-tms-api/order`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherTake() {
      this.modelTakeFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      if (modelFlag == "take") {
        this.modelTakeFlag = false;
      }
    },
    formatterQuote(data) {
      let genre = data.row.isQuote;
      if (data.row.pushTarget != void 0 && data.row.pushTarget != "") {
        genre = 2;
      }
      return this.isQuoteMap[genre];
    },
    open(data) {
      this.shipmodal = true;
      this.ShipmentQuery.mainOrderCode = data.code;
      if (data.coalNumber != 0) {
        this.jinzhis = true;
      }
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            [
              "coalNumber",
              "notReceivedCount",
              "receivedCount",
              "transferCount"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "weight") {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          if (column.property === "lastWeight") {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }

          return "-";
        })
      ];
    }
  }
};
</script>
